import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationScroll = ({ children }) => {
    const location = useLocation();
    const { pathname = '/' } = location;

    const scroll = () =>
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });

    // useEffect(() => { scroll(); });
    // useEffect(() => { scroll(); }, []);
    useEffect(() => {
        scroll();
    }, [pathname]);

    return children;
};

export default NavigationScroll;
